//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "alliance-detail",
    data() {
        return {
            title: "积分明细",
            page: 1, //获取第几页数据
            per_page: "4", //每一页条数
            details: [],
            url: window.location.href //当前地址
        };
    },
    created() {
        if (sessionStorage.getItem("token") == null) {
            this.get_token(this.url);
        }
    },
    methods: {
        //获取token
        get_token(url) {
            var self = this;
            this.$EpetJs.Common.approve(url,function() {
                self.$refs.infiniteLoading.$emit(
                    "$InfiniteLoading:reset"
                );
            }); //生成token
        },
        //获取积分信息
        infiniteHandler($state) {
            var self = this;
            if (sessionStorage.getItem("token") == null) {
                return;
            }
            this.$EpetJs.Common.get(
                "public/score_logs?page=" +
                    this.page +
                    "&per_page=" +
                    this.per_page,
                {}
            ).then(({ data }) => {
                if (data.status_code == "200") {
                    if (data.data.length > 0) {
                        self.details = self.details.concat(data.data);
                        self.page += 1;
                        $state.loaded();
                    } else {
                        $state.complete();
                    }
                }
            });
        }
    }
};
